
export const UpdateManager = () => {
  return (
    <div>UpdateManager</div>
  )
}
